// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Job } from './job';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class RecurringJob extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  uncompletedJobs: number = 0;
  completedJobs: number = 0;

  get displayFrequency() {
      return [this.frequency.toString(), this.frequency != 1 ? this.frequencyUnit : this.frequencyUnit.slice(0, -1)].join(' ');
  }

  calcUncompletedJobs() {
    this.uncompletedJobs = this.jobs.filter(x => !x.deleted && !x.completed).length;
  }

  calcCompletedJobs() {
    this.completedJobs = this.jobs.filter(x => !x.deleted && x.completed).length;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  endDate!: Date;
  frequency!: number;
  frequencyUnit?: string;
  startDate!: Date;
  jobs!: Job[];
}

